import { DataTable, Dialog, Heading, Loader } from "@/components";
import { Button, Input } from "@/components/ui";
import usePropertyZone from "./useTncVariable";
import { Search } from "lucide-react";

const PropertyZone = () => {
  const {
    onAdd,
    isMobile,
    globalFilter,
    setGlobalFilter,
    columns,
    isLoadingPropertyZones,
    propertyZones,
    openDeleteDialog,
    setOpenDeleteDialog,
    deletedRow,
    isDeletePropertyZonePending,
    onDeleteConfirm,
    isOwner,
    hasAddPermission
  } = usePropertyZone();

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading title="TnC Variables" />
          {!isOwner && isMobile && hasAddPermission && (
            <Button onClick={onAdd} className="px-2">
              + Add Variable
            </Button>
          )}
        </div>
        <div className="flex flex-row items-center gap-4">
          <Input
            type="text"
            placeholder="Search"
            value={globalFilter ?? ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="w-full sm:w-72 bg-white h-[40px]"
            startIcon={<Search className="w-4 h-4" />}
          />
          {!isOwner && !isMobile && hasAddPermission && (
            <Button onClick={onAdd}>+ Add Variable</Button>
          )}
        </div>
      </div>

      {/* Responsive Table */}
      {isLoadingPropertyZones ? (
        <Loader />
      ) : (
        <>
          <DataTable
            columns={columns}
            data={propertyZones?.data || []}
            setGlobalFilter={setGlobalFilter}
            globalFilter={globalFilter}
          />
          <Dialog
            open={openDeleteDialog}
            setOpen={setOpenDeleteDialog}
            title={
              <div className="text-2xl font-bold text-primary">
                {"Confirmation"}
                <div className="h-1 w-[30%] bg-primary rounded-full" />
              </div>
            }
            saveText="Delete"
            saveBtnClassName="bg-red-500 text-white hover:bg-red-500 hover:text-white"
            isLoading={isDeletePropertyZonePending}
            onSave={onDeleteConfirm}
          >
            <p className="text-sm">
              Are you sure you want to delete this TnC Variable -{" "}
              <span className="font-bold text-primary">
                {deletedRow?.tagName}
              </span>
              ? This action cannot be undone
            </p>
          </Dialog>
        </>
      )}
    </div>
  );
};

export default PropertyZone;
